import { render, staticRenderFns } from "./AddClosuresPopup.vue?vue&type=template&id=1c0d4e56"
import script from "./AddClosuresPopup.vue?vue&type=script&lang=ts"
export * from "./AddClosuresPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports